import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { ONBOARDING_ROUTE } from "@/shared/lib/routes";
import { resetCacheOnScopeChange } from "@/shared/gql/apollo-client";
import { syncAnalyticsCompany } from "@/shared/lib/analytics";

const CompanyLayout = () => {
  return <Outlet />;
};

export const Route = createFileRoute("/_authed/_noSidebar/$companySlug")({
  component: CompanyLayout,
  beforeLoad: ({ context, params, preload }) => {
    const company = context.me?.companies.find(
      (c) => c.slug === params.companySlug,
    );
    if (!company) throw redirect({ to: "/" });
    // A deep link straight to the billing pages must still carry the company, so the
    // checkout funnel is attributed to it. Not on a preload, which only means a hover.
    if (!preload) syncAnalyticsCompany(company);
    if (!company.onboardingCompletedAt) {
      throw redirect({ to: ONBOARDING_ROUTE });
    }
    // The billing routes below read company-scoped data too, so a deep link straight here
    // must drop the previous company's cache just like the main tree does.
    resetCacheOnScopeChange(company.slug);
    return { company };
  },
});
